// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts"
// @generated from file gitpod/v1/ona_intelligence.proto (package gitpod.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { CreateOrganizationLLMConfigurationRequest, CreateOrganizationLLMConfigurationResponse, DeleteOrganizationLLMConfigurationRequest, DeleteOrganizationLLMConfigurationResponse, GetOrganizationLLMConfigurationRequest, GetOrganizationLLMConfigurationResponse, GetOrganizationLLMUsageRequest, GetOrganizationLLMUsageResponse, ListOrganizationLLMConfigurationsRequest, ListOrganizationLLMConfigurationsResponse, UpdateOrganizationLLMConfigurationRequest, UpdateOrganizationLLMConfigurationResponse } from "./ona_intelligence_pb.js";
import { MethodIdempotency, MethodKind } from "@bufbuild/protobuf";

/**
 * OnaIntelligenceService manages organization-level LLM configurations for Ona Intelligence.
 * This service is restricted to Ona employees with the OnaIntelligenceAdmin role.
 *
 * @generated from service gitpod.v1.OnaIntelligenceService
 */
export const OnaIntelligenceService = {
  typeName: "gitpod.v1.OnaIntelligenceService",
  methods: {
    /**
     * Creates or updates the Anthropic API key configuration for an organization.
     *
     * Use this method to:
     * - Configure Anthropic API access for an organization
     * - Rotate existing API keys
     *
     * The API key is encrypted before storage using organization-scoped encryption.
     *
     * @generated from rpc gitpod.v1.OnaIntelligenceService.CreateOrganizationLLMConfiguration
     */
    createOrganizationLLMConfiguration: {
      name: "CreateOrganizationLLMConfiguration",
      I: CreateOrganizationLLMConfigurationRequest,
      O: CreateOrganizationLLMConfigurationResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Updates the Anthropic API key configuration for an organization.
     *
     * Use this method to:
     * - Update existing API key
     * - Modify configuration settings
     *
     * Only provided fields will be updated (partial update).
     *
     * @generated from rpc gitpod.v1.OnaIntelligenceService.UpdateOrganizationLLMConfiguration
     */
    updateOrganizationLLMConfiguration: {
      name: "UpdateOrganizationLLMConfiguration",
      I: UpdateOrganizationLLMConfigurationRequest,
      O: UpdateOrganizationLLMConfigurationResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Gets metadata about the organization's LLM configuration.
     *
     * Use this method to:
     * - Check if an organization has an API key configured
     * - View when the key was last updated
     *
     * For security reasons, this method does not return the actual API key,
     * only metadata including the last 4 characters for identification.
     *
     * @generated from rpc gitpod.v1.OnaIntelligenceService.GetOrganizationLLMConfiguration
     */
    getOrganizationLLMConfiguration: {
      name: "GetOrganizationLLMConfiguration",
      I: GetOrganizationLLMConfigurationRequest,
      O: GetOrganizationLLMConfigurationResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * Lists all organization LLM configurations.
     *
     * Use this method to:
     * - View all organizations with LLM configurations
     * - Audit API key usage
     *
     * @generated from rpc gitpod.v1.OnaIntelligenceService.ListOrganizationLLMConfigurations
     */
    listOrganizationLLMConfigurations: {
      name: "ListOrganizationLLMConfigurations",
      I: ListOrganizationLLMConfigurationsRequest,
      O: ListOrganizationLLMConfigurationsResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * Deletes the organization's LLM API key configuration.
     *
     * Use this method to:
     * - Remove API key access for an organization
     * - Clean up unused configurations
     *
     * @generated from rpc gitpod.v1.OnaIntelligenceService.DeleteOrganizationLLMConfiguration
     */
    deleteOrganizationLLMConfiguration: {
      name: "DeleteOrganizationLLMConfiguration",
      I: DeleteOrganizationLLMConfigurationRequest,
      O: DeleteOrganizationLLMConfigurationResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Gets credit usage summary for the caller's organization.
     *
     * The organization is inferred from the caller's identity.
     *
     * Use this method to:
     * - View Ona credit consumption for your organization
     * - Track usage over time
     * - Display usage data to organization admins
     *
     * Returns pre-aggregated summaries for week, month, and year.
     *
     * @generated from rpc gitpod.v1.OnaIntelligenceService.GetOrganizationLLMUsage
     */
    getOrganizationLLMUsage: {
      name: "GetOrganizationLLMUsage",
      I: GetOrganizationLLMUsageRequest,
      O: GetOrganizationLLMUsageResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
  }
} as const;

